/*
    Examples
    =========
    {
        type: "list",
        textField: "",
        valueField: "",
        data: {
          values: [],
          ajax: {
            url: "",
            method: "",
            args: {},
          },
        },
      }

*/
export const filterTypes = {
  TEXT: "text",
  NUMBER: "number",
  FLOAT: "float",
  DATE: "date",
  YESNO: "yesno",
  LIST: "list",
};

// https://alirezanet.github.io/Gridify/guide/filtering.html#conditional-operators
const values = {
  startsWith: { text: "Starts with", value: "^" },
  notStartsWith: { text: "Not starts with", value: "!^" },
  endsWith: { text: "Ends with", value: "$" },
  notEndsWith: { text: "Not ends with", value: "!$" },
  contains: { text: "Contains", value: "=*" },
  notContains: { text: "Does not contain", value: "!*" },
  equal: { text: "Equal", value: "=" },
  notEqual: { text: "Not Equal", value: "!=" },
  greaterThan: { text: "Greater Than", value: ">" },
  greaterThanOrEqual: {
    text: "Greater Than Or Equal",
    value: ">=",
  },
  lessThan: { text: "Less Than", value: "<" },
  lessThanOrEqual: {
    text: "Less Than Or Equal",
    value: "<=",
  },
  between: { text: "Between", value: "><" },
  notBetween: { text: "Not between", value: "<>" },
};

export const operators = {
  [filterTypes.TEXT]: [
    values.startsWith,
    values.notStartsWith,
    values.endsWith,
    values.notEndsWith,
    values.contains,
    values.notContains,
    values.equal,
    values.notEqual,
  ],
  [filterTypes.NUMBER]: [
    values.equal,
    values.notEqual,
    values.greaterThan,
    values.greaterThanOrEqual,
    values.lessThan,
    values.lessThanOrEqual,
    values.between,
    values.notBetween,
  ],
  [filterTypes.FLOAT]: [
    values.equal,
    values.notEqual,
    values.greaterThan,
    values.greaterThanOrEqual,
    values.lessThan,
    values.lessThanOrEqual,
    values.between,
    values.notBetween,
  ],
  [filterTypes.DATE]: [
    values.equal,
    values.notEqual,
    values.greaterThan,
    values.greaterThanOrEqual,
    values.lessThan,
    values.lessThanOrEqual,
    values.between,
    values.notBetween,
  ],
  [filterTypes.YESNO]: [values.equal, values.notEqual],
  [filterTypes.LIST]: [values.equal, values.notEqual],
};
